import { _cacheMap, DiffFile } from '@git-diff-view/core';
export * from '@git-diff-view/core';
import { createTwoFilesPatch } from 'diff';

_cacheMap.name = "@git-diff-view/file";
function generateDiffFile(oldFileName, oldFileContent, newFileName, newFileContent, oldFileLang, newFileLang, option, uuid) {
    const diffString = createTwoFilesPatch(oldFileName, newFileName, oldFileContent, newFileContent, "", "", option);
    return new DiffFile(oldFileName, oldFileContent, newFileName, newFileContent, [diffString], oldFileLang, newFileLang, uuid);
}

export { generateDiffFile };
//# sourceMappingURL=index.mjs.map
